import React from "react";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import "../styles/about.css"

const Testimonials = () => {
  return (
    <div className="container testimonials-container mt-5">
      <h2 className="text-center mb-4">Stories of Client Satisfaction</h2>
      <div className="row justify-content-center">
        <div className="col-md-4 mb-4" > {/* Changed to col-md-4 for three columns */}
          <iframe
            className="w-100"
            height="315"
            src="https://www.youtube.com/embed/nzFB1-Gahio?si=-b7IGBAjKORO167W"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
           
          ></iframe>
        </div>
        <div className="col-md-4 mb-4"> {/* Changed to col-md-4 for three columns */}
          <iframe
            className="w-100"
            height="315"
            src="https://www.youtube.com/embed/MvQ30DKkaF4?si=nq0mJjhQ-WY57e_u"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
        <div className="col-md-4 mb-4"> {/* Added third video column */}
          <iframe
            className="w-100"
            height="315"
            src="https://www.youtube.com/embed/mZDq9qNTclY?si=3hdoxBOEAsNlpVsx" // Replace with actual video ID
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
